import React, { useState } from "react";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import "./CardWrapper.scss";
import CategoryRadarChart from "./DataEstateCards/CategoryRadarChart";

export default function CardWrapper({ title, rightElement, children }) {
  const [showSpider, setShowSpider] = useState(true);

  const isCategorySummary = title === "Category" ;
  const isSensitivitySummary = title === "Sensitivity" || title === "Regulated";

  return (
    <div className="card-wrapper">
      {title !== "Size Analysis" && (
        <div
          className={isCategorySummary || isSensitivitySummary ? "card-header category" : "card-header"}
        >
          <span>{title}</span>

          <div className="data-estate-category-toggle">
            {isCategorySummary && (
              <FormControlLabel
                control={
                  <Switch
                    checked={showSpider}
                    onChange={() => setShowSpider(!showSpider)}
                    color="primary"
                    sx={{
                      transform: "scale(0.8)",
                      marginRight: "-6px",
                    }}
                  />
                }
              />
            )}

            {rightElement}
          </div>
        </div>
      )}

      {isCategorySummary && showSpider ? (
        <div className="spider-graph-box">
          <CategoryRadarChart />
        </div>
      ) : (
        <div className={title !== "Size Analysis" ? "card-body" : null}>
          {children}
        </div>
      )}
    </div>
  );
}
